interface DocumentsQueryKeyArgs {
  pursuitId: string
}

export const documentsQueryKeys = {
  all: () => ['documents'] as const,
  pursuit: (keyArgs: DocumentsQueryKeyArgs) =>
    ['documents', keyArgs.pursuitId] as const,
}

interface DocumentQueryKeyArgs {
  documentId: string
}

export const documentQueryKeys = {
  all: () => ['document'] as const,
  document: (keyArgs: DocumentQueryKeyArgs) =>
    ['document', keyArgs.documentId] as const,
  seedStatus: (keyArgs: DocumentQueryKeyArgs) =>
    ['document', keyArgs.documentId, 'seed-status'] as const,
}
